var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { lottieAnimations } from '@backrs_ui/common-ui/src/assets/lottieAnimations';
import { Box } from '@mui/material';
import Lottie from 'lottie-react';
var ANIMATION_WIDTH = 220;
var loadingAnimations = [
    lottieAnimations.zigzag,
    lottieAnimations.blob,
    lottieAnimations.teardrop,
    lottieAnimations.cloud,
    lottieAnimations.starburst,
];
export var FullScreenLoading = function (_a) {
    var _b = _a.fillContainer, fillContainer = _b === void 0 ? false : _b;
    var animation = useState(function () { return loadingAnimations[Math.floor(Math.random() * loadingAnimations.length)]; })[0];
    return (_jsx(Box, { sx: fillContainer ? fillContainerSx : fullScreenSx, children: _jsx(Lottie, { animationData: animation, loop: true, style: { width: ANIMATION_WIDTH } }) }));
};
var centeredSx = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};
var fullScreenSx = function (_a) {
    var backrs = _a.backrs;
    return (__assign(__assign({}, centeredSx), { height: '100dvh', width: '100dvw', backgroundColor: backrs.colors['Beige/25'] }));
};
var fillContainerSx = __assign(__assign({}, centeredSx), { height: '100%', width: '100%', flex: 1 });
